import React, {FC, useLayoutEffect, useRef} from "react";
import { gsap } from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import planeImg from "./plane.png";
import "./Plane.scss"

// const {MotionPathHelper} = require("../../scripts/MotionPathHelper.js");
// gsap.registerPlugin(MotionPathPlugin, MotionPathHelper);

gsap.registerPlugin(MotionPathPlugin);
const Plane: FC = () => {
	const plane = useRef<HTMLDivElement>(null);
	let planeTween: any;

	const startPlaneBend = () => {
		setTimeout(() => {
			gsap.fromTo(plane.current, {rotate: 0}, {rotate: -5, repeat: -1, duration: 2, delay: 0, repeatDelay: 2});
			gsap.fromTo(plane.current, {rotate: -5}, {rotate: 0, repeat: -1, duration: 2, delay: 2, repeatDelay: 2});
		}, 500)
	}

	const createPlaneTween = () => {
		let progress = planeTween ? planeTween.progress() : 0
		planeTween && planeTween.progress(0).kill()
		planeTween = gsap.to(plane.current, {
			duration: 5,
			motionPath:{
				path: "#plane-path",
				align: "#plane-path",
				autoRotate: true,
				alignOrigin: [0.5, 0.5]
			},
			onComplete: () => startPlaneBend()
		});
		planeTween.progress(progress);
	}

	useLayoutEffect(() => {
		window.addEventListener("resize", createPlaneTween);
		createPlaneTween();
		//MotionPathHelper.create(plane.current);
		return () => window.removeEventListener("resize", createPlaneTween);
	}, []);

	return(
		<div id="plane" ref={plane}>
			<img src={planeImg} alt="plane" />
		</div>
	)
}
export default Plane